import React, { useEffect } from 'react';

const APILink = props => {
    let name = props.apiLinkData.name
    let apiLink = props.apiLinkData.properties[0].url;
    let apiDefaultVersion = props.apiLinkData.properties[1].value;

    // Remove the version from the URL
    let parts = apiLink.split('/');
    parts.pop();  // Remove the last element
    apiLink = parts.join('/');

    function handleClick() {
      props.updateApiLink(apiLink, apiDefaultVersion)
    }

    useEffect(() => {
      if (props.first) {  // If this is the first APILink
          handleClick();
      }
    }, [props.first]);

  return (  
    <div className="api-link" onClick={() => handleClick()}>
      {name}
    </div>
  )
}

export default APILink;